<template>
  <div class="box-father">
    <div class="box-header">
      <div class="box-header-left">
        <div class="box-header-left-text">任务管理&nbsp;/&nbsp;</div>
        <div class="box-header-right">
          <div>巡逻日历管理</div>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="title">巡逻日历管理</div>
      <div class="select-box">
        <div style="display: flex;align-items: center;">
          <div class="select-label">日历月份</div>
          <el-date-picker
            value-format="yyyy-MM"
            v-model="year"
            type="month"
            placeholder="选择月份"
            @change="yearChange"
          >
          </el-date-picker>
        </div>
        <div style="display: flex;align-items: center;">
          <el-button class="other el-icon-download" @click="downloadFileFun"
            >模板下载</el-button
          >
          <el-upload
            class="upload-demo"
            accept=".xlsx"
            action="#"
            :auto-upload="false"
            :show-file-list="false"
            :on-change="importDataFun"
          >
            <el-button class="other el-icon-upload2">数据导入</el-button>
          </el-upload>
        </div>
      </div>
      <div class="rl-box">
        <div class="left">
          <el-checkbox-group v-model="modifyDateList">
            <el-calendar :first-day-of-week="7" v-model="value">
              <!-- 这里使用的是 2.5 slot 语法，对于新项目请使用 2.6 slot 语法-->
              <div
                @click.stop="setSchedule(data.day)"
                slot="dateCell"
                class="calendarday"
                slot-scope="{ date, data }"
              >
                <div v-if="data.type == 'current-month'">
                  <el-checkbox :label="data.day"><br /></el-checkbox>
                </div>
                <div class="day" :class="{ today: getCurrentDate(data.day) }">
                  {{ handleDay(data.day) }}
                </div>
                <div class="status" v-if="data.type == 'current-month'">
                  <span :class="{ xiu: isHoliday(data.day) }">
                    {{ isHoliday(data.day) ? "休" : "班" }}</span
                  >
                </div>
              </div>
            </el-calendar>
          </el-checkbox-group>
        </div>
        <div class="right" v-if="modifyDateList.length">
          <div class="title">当前选择：</div>
          <el-tag
            v-for="tag in modifyDateList"
            :key="tag"
            closable
            type="info"
            @close="handleDelete(tag)"
          >
            {{ tag }}
          </el-tag>
          <div
            style="margin-top: 48px;margin-bottom: 16px;font-family: MiSans, MiSans;
                font-weight: 400;
                font-size: 16px;
                color: #494C4F;"
          >
            日期类型
          </div>
          <el-radio-group v-model="workingFlag">
            <el-radio label="1">工作日</el-radio>
            <el-radio label="0">节假日</el-radio>
          </el-radio-group>
          <div class="footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" @click="batchEditFun">确 认</el-button>
          </div>
        </div>
        <div class="right right1" v-else>
          <div class="top">
            <div class="title">当前选择：</div>
          </div>
          <div class="empoy-box">
            <img src="@/assets/image/empty.png" alt="" />
            <div class="text-box">暂无数据</div>
            <div class="text-box text-box1">勾选左侧日期更改日期类型</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { holidayslist, importModify, batchEdit } from "@/api/task.js";
import { downloadFile } from "@/api/systemManagement.js";
import moment from "moment";
import solarLunar from "solarlunar-es";
export default {
  data() {
    return {
      year: moment(new Date()).format("YYYY-MM"),
      value: moment(new Date()).format("YYYY-MM-DD"),
      scheduleList: [],
      modifyDateList: [],
      workingFlag: "1"
    };
  },
  methods: {
    yearChange(value) {
      this.value = value + "-01";
    },
    handleClose() {
      this.workingFlag = "1";
      this.modifyDateList = [];
    },
    handleDelete(value) {
      const index = this.modifyDateList.indexOf(value);
      if (index > -1) {
        this.modifyDateList.splice(index, 1);
      }
    },
    // 获取当前日期
    getCurrentDate(date) {
      // 判断是否为今天
      const today = moment().format("YYYY-MM-DD");
      const currentDate = moment(date).format("YYYY-MM-DD");
      if (today === currentDate) {
        return true;
      }
      return false;
    },
    // 设置排班
    setSchedule(date) {
      this.value = moment(date).format("YYYY-MM-DD");
    },
    // 判断是否法定节假日及工作日
    isHoliday(date) {
      const times =
        this.scheduleList
          .filter(item => item.workingFlag == "0")
          .map(e => e.modifyDate) || [];
      // 公历
      const solar = this.handleSolar(date);
      // console.log(solar,"solar");
      // 判断是否为非工作日
      if (times.length && times.includes(moment(date).format("YYYY-MM-DD"))) {
        return true;
      }

      // 如果为周六日
      if (solar.nWeek === 7 || solar.nWeek === 6) {
        // 如果周六日设置为工作日
        if (
          times.length &&
          !times.includes(moment(date).format("YYYY-MM-DD"))
        ) {
          return false;
        }
        return true;
      }
      return false;
    },
    // 日期转农历
    handleSolar(date) {
      const year = moment(date).year();
      const month = moment(date).month() + 1;
      const day = moment(date).date();
      // 公历
      const solar = solarLunar.solar2lunar(year, month, day);
      return solar;
    },
    // 处理日期
    handleDay(date) {
      const day = moment(date).date();
      // if (day === 1) {
      //   return moment(date).format("M月D日");
      // }
      return day;
    },
    async holidayslistFun() {
      const res = await holidayslist({
        timeStr: this.year
      });
      this.scheduleList = res.data.data;
    },
    // 模板下载
    async downloadFileFun() {
      const res = await downloadFile({
        filePath: "/template/批量修改节假日模板.xlsx"
      });
      let fileReader = new FileReader();
      fileReader.onload = function() {
        try {
          if (res.code == 300) {
            // 说明是普通对象数据，后台转换失败
            // proxy.MSG.error(res.message);
            return;
          } else {
            // 解析成对象失败，说明是正常的文件流
            let url = window.URL.createObjectURL(new Blob([res.data]));
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.target = "_blank";
            link.setAttribute("download", "批量修改节假日模板.xlsx");
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
          }
        } catch (err) {
          console.log(err);
        }
      };
      fileReader.readAsText(res.data);
    },
    // 数据导入
    async importDataFun(file) {
      if (!file.name.endsWith(".xlsx")) {
        this.$message({
          message: "请上传正确格式文件，支持文件类型：.xlsx",
          type: "warning"
        });
        return;
      }
      let formData = new FormData();
      formData.append("file", file.raw);
      const res = await importModify(formData);
      if (res.data.code == 200) {
        this.$message({
          message: "导入成功",
          type: "success"
        });
        this.holidayslistFun();
      } else {
        this.$message({
          message: `${res.data.msg}`,
          type: "warning"
        });
      }
    },
    async batchEditFun() {
      const res = await batchEdit({
        workingFlag: this.workingFlag,
        modifyDateList: this.modifyDateList
      });
      if (res.data.code == 200) {
        this.$message({
          message: "提交成功",
          type: "success"
        });
        this.handleClose();
        this.holidayslistFun();
      } else {
        this.$message({
          message: `${res.data.msg}`,
          type: "warning"
        });
      }
    }
  },
  watch: {
    year: {
      deep: true,
      immediate: true,
      handler(newValue, oldValue) {
        this.holidayslistFun();
      }
    },
    value: {
      deep: true,
      immediate: true,
      handler(newValue, oldValue) {
        this.year = moment(newValue).format("YYYY-MM");
      }
    }
  }
};
</script>
<style scoped lang="less">
@import "~@/components/less.less";
.box-father,
.box-father .section {
  height: auto;
}
.title {
  font-family: MiSans, MiSans;
  font-weight: 700;
  font-size: 20px;
  color: #494c4f;
}

.box-father {
  padding-bottom: 24px;
}
.select-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 24px;
  .select-label {
    font-family: MiSans, MiSans;
    font-weight: 400;
    font-size: 16px;
    color: #494c4f;
    margin-right: 16px;
  }
}
.rl-box {
  width: 100%;
  height: calc(100% - 114px);
  display: flex;
  margin-top: 20px;
  .left {
    width: calc(100% - 369px);
    height: 100%;
    /deep/.el-calendar__body {
      padding: 0 16px 0 0;
    }
    /deep/ .el-calendar-table {
      thead {
        th::before {
          content: "周";
        }

        th {
          font-family: MiSans, MiSans;
          font-weight: 400;
          font-size: 18px;
          color: #494c4f;
          text-align: center;
          background: #fff;
          border: 1px solid #eeeeee;
        }
      }
    }
    /deep/.el-calendar__header {
      display: none;
    }
    /deep/ .el-calendar-table .el-calendar-day {
      height: 120px;
      padding: 12px;
    }

    // 当前月
    /deep/.el-calendar-table__row .current .el-calendar-day {
      padding: 0px;
    }

    // 工作日
    /deep/.el-calendar-table__row .current .el-calendar-day .calendarday {
      padding: 12px;
      width: 100%;
      height: 100%;
    }

    .day {
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 18px;
      color: #494c4f;
      text-align: center;
      margin-top: 16px;
    }
    .status {
      text-align: center;
      margin-top: 8px;
      span {
        display: inline-block;
        background: rgba(138, 144, 154, 0.09);
        border-radius: 2px;
        font-family: MiSans, MiSans;
        font-weight: 400;
        font-size: 14px;
        color: #92979c;
        padding: 2px 6px;
      }
      .xiu {
        background: rgba(12, 206, 179, 0.1);
        color: #00ac94;
      }
    }
    /deep/.el-calendar-table__row .prev .el-calendar-day,
    /deep/.el-calendar-table__row .next .el-calendar-day {
      background: #f5f6f7;
      .day {
        font-family: MiSans, MiSans;
        font-weight: 400;
        font-size: 18px;
        color: #92979c;
        margin-top: 36px;
      }
    }

    .today {
      font-family: MiSans, MiSans;
      font-weight: 500;
      font-size: 24px;
      color: #0090ff !important;
      margin-top: 8px;
    }
  }
  .right {
    width: 369px;
    height: 778px;
    padding: 32px 18px;
    border-radius: 4px;
    border: 1px solid #e0e0e0;
    position: relative;
    background: url("~@/assets/image/yjjh.png") right top no-repeat !important;
    background-size: 160px 240px !important;
    .footer {
      position: absolute;
      bottom: 12px;
      right: 16px;
    }
  }
  .right1 {
    background: linear-gradient(
      180deg,
      #eef8ff 0%,
      rgba(255, 255, 255, 0) 100%
    ) !important;
    .top {
      height: 240px;
      width: 100%;
      background: url("~@/assets/image/yjjh.png") right top no-repeat !important;
      background-size: 160px 240px !important;
    }
    .empoy-box {
      margin-top: 60px;
      text-align: center;
      img {
        width: 160px;
        height: 126px;
      }
      .text-box {
        font-family: MiSans, MiSans;
        font-weight: 400;
        font-size: 14px;
        color: #494c4f;
        margin-top: 8px;
      }
      .text-box1 {
        font-family: MiSans, MiSans;
        font-weight: 400;
        font-size: 13px;
        color: #92979c;
      }
    }
  }
}
/deep/.el-tag.el-tag--info {
  margin-top: 16px;
  margin-right: 16px;
}
</style>



// WEBPACK FOOTER //
// src/pages/task/patrolCalendar/index.vue